import React, { useState } from "react";
import "./DashboardHeader.scss";
import { RiRefreshLine } from "react-icons/ri";
const initiaData = [
  {
    title: "Load",
    value: 17,
    route: "Load",
  },
  {
    title: "Vendor Account",
    value: 0,
    route: "VendorAccount",
  },
  {
    title: "Truck Master",
    value: 6,
    route: "TruckMaster",
  },
  {
    title: "Booking",
    value: "5,46,07,857.24",
    route: "Booking",
  },
  {
    title: "Customer Account",
    value: "94,60,105.56",
    route: "CustomerAccount",
  },
  {
    title: "Vehicle Owner Account",
    value: "9,09,122.07",
    route: "VehicleOwnerAccount",
  },
];

const DashboardHeader = () => {
  const [data, setDate] = useState(initiaData);

  return (
    <div></div>
  );
};

export default DashboardHeader;
